module.exports = __webpack_public_path__ + "static/media/10.99edc453.jpg";